(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqs-section"] && !Shopify.designMode) return;
  try {
    
  
// FAQ Accordion  
$('.faq-col-item:first-child > .accordion-item > .accordion-item-trigger').addClass('is-active');
  $('.faq-col-item:first-child > .accordion-item > .accordion-item-trigger .accordion-trigger-icon .accordion-trigger-icon-line.v').addClass('open');
$('.faq-col-item:first-child > .accordion-item > .accordion-item-content').slideDown();

$('.accordion-item > .accordion-item-trigger').unbind().click(function() {
    if ($(this).hasClass('is-active')) {
        $(this).siblings('.accordion-item-content').slideUp(200);
        $(this).removeClass('is-active');
        $(this).children('.accordion-trigger-icon').find('.accordion-trigger-icon-line.v').toggleClass("open");
      
        
    } else {
        $('.accordion-item-content').slideUp();
        $('.accordion-item > .accordion-item-trigger').removeClass('is-active');
        $(this).siblings('.accordion-item-content').slideToggle(200);
        $(this).toggleClass('is-active');
        $(this).children('.accordion-trigger-icon').find('.accordion-trigger-icon-line.v').toggleClass("open");
      
    }
});
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products-section"] && !Shopify.designMode) return;
  try {
    
  $(function() {
    $('.featured-products-grid').owlCarousel({
        loop:false,
        nav:false,
        autoplay:false,
        dots: false,
        margin: 76,
        thumbs: false,
        thumbImage: false,
        responsive:{
            0:{
                items:1.5
            },
            750:{
                items:3.5
            },
            990:{
                items:4
            }
        }
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);
  
  $(document).ready(function() {
    $('#enquireFormButton').on('click',  function(e) {
      e.preventDefault();
      localStorage.setItem('fillingContactForm', 'true');
      $('.enquire-form-modal-wrapper').fadeIn(300);
    });

    $('.enquire-form-close-button').on('click',  function(e) {
      e.preventDefault();
      console.log('Enquire Form Closing');
      localStorage.setItem('fillingContactForm', 'false');
      $('.enquire-form-modal-wrapper').fadeOut(300);
    });
    
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-carousel-section"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {

    $.each($('.gallery-carousel'), function(i,d) {
      console.log($(d).parent().find('.gallery-carousel-owl-dots-container'), 'asdasdasdasd');

      var modCarousel = $(d).owlCarousel({
        loop:true,
        nav:false,
        dots: true,
        margin: 76,
        // dotsContainer: $(d).parent().find('.gallery-carousel-owl-dots-container'),
        autoplay: true,
        autoplaySpeed: 800,
        autoplayTimeout:6000,
        thumbs: true,
        thumbImage: true,
        thumbContainerClass: 'gallery-carousel-owl-thumbs',
        thumbItemClass: 'gallery-carousel-owl-thumb-item',
        responsive:{
            0:{
                items:1
            },
            750:{
                items:1
            },
            990:{
                items:1
            }
        }
    })
      
    });

  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // $(".mega-menu_child .level-2 > a").on('click', function(e){ 
  //   e.preventDefault();

  //   if($(this).parent().hasClass('dropdown-active')) {
  //     $(this).parent().removeClass('dropdown-active');
  //     $(this).parent().find('.mega-dropdown__bottom').hide();
  //   }
  //   else {
  //     $(".mega-menu_child .level-2").removeClass('dropdown-active');
  //     $(this).parent().addClass('dropdown-active');
  //     $('.mega-dropdown__bottom').hide();
  //     $(this).parent().find('.mega-dropdown__bottom').fadeIn(100);
  //   }
  // });
  


  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hire-equipment-form-section"] && !Shopify.designMode) return;
  try {
    

  $(document).ready(function() {
            var currentDate = new Date();
            var formattedDate = currentDate.toISOString().split('T')[0];
            $('#hidden-1').val(formattedDate);
        });

    $(document).ready(function() {
    function updateStepIndicator() {
        var currentStepPanel = $('.panel.movingIn');
        var currentStep = currentStepPanel.data('step');

        $('.form-stepper-list').removeClass('form-stepper-active');
        $('.form-stepper-list[step="' + currentStep + '"]').addClass('form-stepper-active');
    }

    $('.action').click(function() {
        updateStepIndicator();
    });
});





/**
 * Define a function to navigate betweens form steps.
 * It accepts one parameter. That is - step number.
 */
const navigateToFormStep = (stepNumber) => {
    /**
     * Hide all form steps.
     */
    document.querySelectorAll(".form-step").forEach((formStepElement) => {
        formStepElement.classList.add("d-none");
    });
    /**
     * Mark all form steps as unfinished.
     */
    document.querySelectorAll(".form-stepper-list").forEach((formStepHeader) => {
        formStepHeader.classList.add("form-stepper-unfinished");
        formStepHeader.classList.remove("form-stepper-active", "form-stepper-completed");
    });
    /**
     * Show the current form step (as passed to the function).
     */
    document.querySelector("#step-" + stepNumber).classList.remove("d-none");
  
    $('html, body').animate({
      scrollTop: $("#step-" + stepNumber).offset().top - 150
    })
    /**
     * Select the form step circle (progress bar).
     */
    const formStepCircle = document.querySelector('li[step="' + stepNumber + '"]');
    /**
     * Mark the current form step as active.
     */
    formStepCircle.classList.remove("form-stepper-unfinished", "form-stepper-completed");
    formStepCircle.classList.add("form-stepper-active");
    /**
     * Loop through each form step circles.
     * This loop will continue up to the current step number.
     * Example: If the current step is 3,
     * then the loop will perform operations for step 1 and 2.
     */
    for (let index = 0; index < stepNumber; index++) {
        /**
         * Select the form step circle (progress bar).
         */
        const formStepCircle = document.querySelector('li[step="' + index + '"]');
        /**
         * Check if the element exist. If yes, then proceed.
         */
        if (formStepCircle) {
            /**
             * Mark the form step as completed.
             */
            formStepCircle.classList.remove("form-stepper-unfinished", "form-stepper-active");
            formStepCircle.classList.add("form-stepper-completed");
        }
    }
};
/**
 * Select all form navigation buttons, and loop through them.
 */
document.querySelectorAll(".btn-navigate-form-step").forEach((formNavigationBtn) => {
    /**
     * Add a click event listener to the button.
     */
    formNavigationBtn.addEventListener("click", () => {
        /**
         * Get the value of the step.
         */
        const stepNumber = parseInt(formNavigationBtn.getAttribute("step_number"));
        /**
         * Call the function to navigate to the target form step.
         */

        // Check if the clicked button is 'Next'
        if(formNavigationBtn.innerHTML == 'Next') {
          // console.log('Next is clicked');

          let currentStep = formNavigationBtn.getAttribute("current_step");
          console.log('currentStep: '+currentStep);
          
          let FormValidationError = 0;
          // $.each($('#multi-step-form-container input'), function(i, d) {
          $.each($('#'+currentStep+' .field__input'), function(i, d) {
          
          
          	let requiredAttr = $(d).attr('required');
          
          	if($(d).val() == '' && typeof requiredAttr !== 'undefined' && requiredAttr !== false) {
                console.log('Error Field: '+ $(d).innerHTML);
            	FormValidationError += 1;
            }
            
            //Email
            const emailRegex = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i
            
            if($(d).attr('type') == 'email' && !emailRegex.test($(d).val())) {
            		FormValidationError += 1;
            }
             
            
          })

          console.log('FormValidationError: ' + FormValidationError);

          if (FormValidationError == 0) {
          	navigateToFormStep(stepNumber);
          }
          else {
          	console.log('Fix Form Errors: ');
            $('#hireFormSubmitButton').trigger('click');
          }
          
        } else {
          navigateToFormStep(stepNumber);
          
        }
      
        // navigateToFormStep(stepNumber);
        
    });
});

//Navigate Using the Numbers
$('.form-stepper-circle').on('click', function() {
  console.log('clicked', $(this).parents('.form-stepper-list').hasClass('form-stepper-completed'));
  if($(this).parents('.form-stepper-list').hasClass('form-stepper-completed')) {
    const stepNumber = parseInt($(this).attr("step_number"));
    console.log(stepNumber)
    navigateToFormStep(stepNumber);
  }
})

// Show success message on page load  
window.onload = function(){
//   if({{ form_success }}){
//     document.querySelector('#modal-success-message').innerHTML = "{{ 'contact.form.post_success' | t }}";
// }
}

$('.billing-info-radio-buttons input[type="radio"][name="contact[personal_details]"]').on('change',function(){
  var ThisIt = $(this);
  if(ThisIt.val() == "Yes"){
    // when user select yes
    $('#billingDetails').fadeOut(100);
    $('#billingDetailsMessage').fadeIn(100);
  }else{
    // when user select no
    $('#billingDetails').fadeIn(100);
    $('#billingDetailsMessage').fadeOut(100);
  }
});

  
var delay = 150;
var errorMessageOffset = 250;

document.addEventListener('invalid', function(e){
   $(e.target).addClass("invalid");
   $('html, body').animate({scrollTop: $($(".invalid")[0]).offset().top - errorMessageOffset }, delay);
}, true);
document.addEventListener('change', function(e){
   $(e.target).removeClass("invalid")
}, true);

  $("#ContactForm-rent-start-date").flatpickr({
    "disable": [
        function(date) {
           // Disable weekends
            if (date.getDay() === 0 || date.getDay() === 6) {
                return true;
            }

           // Disable past days
            const today = new Date();
            today.setHours(0, 0, 0, 0); // Set current time to midnight for accurate comparison
            if (date < today) {
                return true;
            }

            // Disable the current day
            return (
                date.getDate() === today.getDate() &&
                date.getMonth() === today.getMonth() &&
                date.getFullYear() === today.getFullYear()
            );
        }
    ],
    "locale": {
        "firstDayOfWeek": 1 
    }
});

// $(document).ready(function() {
//   var tomorrow = new Date();
//   tomorrow.setDate(tomorrow.getDate() + 1);
  
//   var formattedTomorrow = tomorrow.toISOString().split('T')[0];

//   $('#ContactForm-rent-start-date').attr('min', formattedTomorrow);

//   $('#ContactForm-rent-start-date').on('change', function() {
//     validateDate();
//   });

//   function validateDate() {
//     var inputDate = $('#ContactForm-rent-start-date').val();
//     var selectedDate = new Date(inputDate);

//     if (selectedDate.getDay() === 0 || selectedDate.getDay() === 6) {
//       alert("Please select a date that is not a weekend.");
//       $('#ContactForm-rent-start-date').val(''); 
//     }
//   }
// });





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner-slider"] && !Shopify.designMode) return;
  try {
    
  $(function() {
    
    const imageBannerSlider = $('.image-banner-slider');
    
    imageBannerSlider.owlCarousel({
        loop:true,
        nav:false,
        autoplay:true,
        autoplaySpeed: 800,
        autoplayTimeout:6000,
        autoplayHoverPause:false,
        dots: true,
        thumbs: false,
        thumbImage: false,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:1
            },
            1000:{
                items:1
            }
        }
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
   
  $(document).ready(function(){
    
    // $('.tier-3 .t3-active').parent().parent().slideToggle();
    $('.tier-3 .t3-active').parent().parent().parent().toggleClass("active");
    $('.tier-3 .t3-active').parent().parent().parent().find(".t2-link").toggleClass("t2-active");
    $('.tier-3 .t3-active').parent().parent().parent().find(".t2-link > span").toggleClass("active");
    
    // $('.tier-2 .t2-active').parent().parent().slideToggle();
    $('.tier-2 .t2-active').parent().parent().parent().toggleClass("active");
    $('.tier-2 .t2-active').parent().parent().parent().find(".t1-link").toggleClass("t1-active");
    $('.tier-2 .t2-active').parent().parent().parent().find(".t1-link > span").toggleClass("active");
    
    $("#accordion2 ul li a span").click(function(e){
        e.preventDefault();
        $(this).parent().next().stop().slideToggle();
        $(this).toggleClass("active");
    });
     $("#accordion2 ul ul ul li a span").click(function(e){
        e.preventDefault();
        $(this).parent().next().slideToggle();
        $(this).parent().next().children("a").stop().toggleClass("active");
        $(this).toggleClass("active");
    });
  })

$(document).ready(function(){
    var activeParentItems = $(".collection-filter-item.tier-1.active");

    if (activeParentItems.length > 1) {
        activeParentItems.first().prependTo(".collections-menu-wrapper");
        activeParentItems.eq(1).remove();
        activeParentItems.find("> a > span.active").css("display", "none");
    }
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-info-section"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {

    $('.custom-list-style').each(function() {
      var brExp = /<br\s*\/?>/i;
      var lines = $('.custom-list-style p span').html().split(brExp);

      $(this).empty();
      $(this).append('<ul>');
      for(var i = 0; i < lines.length; i++){
        $(this).children('ul').append('<li>'+lines[i]+'</li>');
      } 
      $(this).append('</ul>');
    });
                  
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

  $('#enquireButton').click(function() {
    console.log('Click');
    $('#enquireFormModal').css("display","flex");
    var skuValue = $('.variant-sku').text().replace('Model: ', '');
    $('#hidden-1').val(skuValue);
  });

  $('#enquireFormModal .modal-content .close').click(function() {
    console.log('Click');
    $('#enquireFormModal').css("display","none");
  });

  $('#enquireFormModal').click(function(event) {
    if (event.target === event.currentTarget) {
        console.log('Click');
        $('#enquireFormModal').css("display","none");
    }
});

  

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meet-the-team-section"] && !Shopify.designMode) return;
  try {
    
  $(function() {
    //Show pop up modal for each clicked card
      $('.team-card').click(function() {
        $(this).parent().find('.team-popup-modal').css('opacity', 1).fadeIn(300);
        $(".header-wrapper").css("position", "static");
        $("body").css("overflow", "auto");
      });
     
     //Pop up close
     $('.team-popup-modal, .team-popup-modal-inner').on('click', function(e) {
       if($(e.target) != $('.page-width') && !$(e.target).parents('.page-width team-popup-container').length) {
       		$('.team-popup-modal').css('opacity', 0).fadeOut(300);
          $(".header-wrapper").css("position", "sticky");
       }
     });
     
      $('.popup-close-button').click(function() {
          $('.team-popup-modal').css('opacity', 0).fadeOut(300);
          $(".header-wrapper").css("position", "sticky");
      });
      
      $(document).keydown(function (event) {
          if (event.keyCode == 27) {
              $('.team-popup-modal').css('opacity', 0).fadeOut(300);
              $(".header-wrapper").css("position", "sticky");
          }
      });
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
  // Get the URL parameters
  const searchParams = new URLSearchParams(window.location.search);

  // Get the form_type parameter
  const formType = searchParams.get('form_type');

  // Check if form_type is equal to customer using jQuery
  if (formType === 'customer') {
    // Do something here
    console.log('Form type is customer');
    //$('.newsletter-form__message').text('You are already subscribed.');

    var messageWrapper = document.querySelector('.newsletter-form__message-wrapper');
    var messageElement = document.createElement('h3');
    messageElement.classList.add('newsletter-form__message', 'newsletter-form__message--success', 'form__message');
    messageElement.innerHTML = "Thank you for subscribing";
    messageWrapper.appendChild(messageElement);

    messageElement.scrollIntoView({ behavior: 'smooth' });
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-brands-partners-section"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {

    // $.each($('.our-brands-carousel'), function(i,d) {
    //   console.log($(d));

    //   var modCarousel = $(d).owlCarousel({
    //     loop:true,
    //     nav:false,
    //     autoplay:false,
    //     dots: false,
    //     margin: 76,
    //     responsive:{
    //         0:{
    //             items:1.75
    //         },
    //         750:{
    //             items:3
    //         },
    //         990:{
    //             items:4
    //         }
    //     }
    //   })
      
    // });

  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upcoming-events-section"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
  // Nothing to hide – all cards render up to the limit.
});

  } catch(e) { console.error(e); }
})();
})();
